// The Material Design icons that templates use with mdicon(name="..."),
// registered by main.js. Importing all of @mdi/js adds about 2.8 MB to the
// first load (ADR-0081). A new icon goes here too: mdi-vue draws mdiAlert
// for a name that is not registered (tests/unit/core_infra/icons.spec.js).
import {
  mdiArrowLeftBoldOutline,
  mdiArrowLeftCircle,
  mdiArrowLeftThinCircleOutline,
  mdiArrowRightBoldOutline,
  mdiArrowRightCircle,
  mdiArrowRightThinCircleOutline,
  mdiBasketPlusOutline,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiClose,
  mdiCurrencyEur,
  mdiEmail,
  mdiEmailOutline,
  mdiEye,
  mdiEyeOff,
  mdiFacebook,
  mdiInstagram,
  mdiMagnify,
  mdiMapMarker,
  mdiMenu,
  mdiMenuRightOutline,
  mdiMinus,
  mdiPhone,
  mdiPhoneOutline,
  mdiPlus,
  mdiShoppingOutline,
  mdiSwapHorizontal,
  mdiTrashCan,
  mdiTruckDeliveryOutline,
  mdiViewGrid,
  mdiViewList,
  mdiWeb,
  mdiWhatsapp,
  mdiYoutube,
} from '@mdi/js'

export const icons = {
  mdiArrowLeftBoldOutline,
  mdiArrowLeftCircle,
  mdiArrowLeftThinCircleOutline,
  mdiArrowRightBoldOutline,
  mdiArrowRightCircle,
  mdiArrowRightThinCircleOutline,
  mdiBasketPlusOutline,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiClose,
  mdiCurrencyEur,
  mdiEmail,
  mdiEmailOutline,
  mdiEye,
  mdiEyeOff,
  mdiFacebook,
  mdiInstagram,
  mdiMagnify,
  mdiMapMarker,
  mdiMenu,
  mdiMenuRightOutline,
  mdiMinus,
  mdiPhone,
  mdiPhoneOutline,
  mdiPlus,
  mdiShoppingOutline,
  mdiSwapHorizontal,
  mdiTrashCan,
  mdiTruckDeliveryOutline,
  mdiViewGrid,
  mdiViewList,
  mdiWeb,
  mdiWhatsapp,
  mdiYoutube,
}
